import type { WeatherHour } from '../../types/db';

export const weather: WeatherHour[] = [
  { time: '00:00', temp: 7, sky: 'Helder', mm: 0 },
  { time: '01:00', temp: 7, sky: 'Helder', mm: 0 },
  { time: '02:00', temp: 6, sky: 'Helder', mm: 0 },
  { time: '03:00', temp: 6, sky: 'Helder', mm: 0 },
  { time: '04:00', temp: 6, sky: 'Helder', mm: 0 },
  { time: '05:00', temp: 6, sky: 'Bewolkt', mm: 0 },
  { time: '06:00', temp: 7, sky: 'Bewolkt', mm: 0 },
  { time: '07:00', temp: 8, sky: 'Bewolkt', mm: 0 },
  { time: '08:00', temp: 9, sky: 'Bewolkt', mm: 0 },
  { time: '09:00', temp: 10, sky: 'Bewolkt', mm: 0 },
  { time: '10:00', temp: 11, sky: 'Bewolkt', mm: 0 },
  { time: '11:00', temp: 11, sky: 'Bewolkt', mm: 0 },
  { time: '12:00', temp: 12, sky: 'Zwaar bewolkt', mm: 0 },
  { time: '13:00', temp: 12, sky: 'Regen', mm: 1.2 },
  { time: '14:00', temp: 11, sky: 'Regen', mm: 2.4 },
  { time: '15:00', temp: 11, sky: 'Regen', mm: 1.6 },
  { time: '16:00', temp: 10, sky: 'Lichte regen', mm: 0.4 },
  { time: '17:00', temp: 10, sky: 'Bewolkt', mm: 0 },
  { time: '18:00', temp: 9, sky: 'Bewolkt', mm: 0 },
  { time: '19:00', temp: 9, sky: 'Bewolkt', mm: 0 },
  { time: '20:00', temp: 8, sky: 'Bewolkt', mm: 0 },
  { time: '21:00', temp: 8, sky: 'Helder', mm: 0 },
  { time: '22:00', temp: 8, sky: 'Helder', mm: 0 },
  { time: '23:00', temp: 7, sky: 'Helder', mm: 0 },
];
